import React from "react";
import { NotificationBox } from "../../components/Notifications";
import { colors } from "../notifications/Notification";
import { Title } from "../../components/Text";
import { Button } from "../../components/Button";
import { ActionText, Flex } from "../../components/Flex";

const VersionNotification = ({ version, lastVersion, onClose, onRefresh, onShowReleaseNotes }) => {

    return(
        <NotificationBox color={colors.info} onClose={onClose}>
            {version
                ? <Flex align="center" gap={{ right: 6 }}>
                    <Title>A new version is available!</Title>
                    <Button link onClick={onRefresh}>Refresh</Button>
                </Flex>
                : <Flex direction="column" gap={{ bottom: 6 }}>
                    <Title>Service Platform v{lastVersion} has been released.</Title>
                    <ActionText onClick={() => onShowReleaseNotes()}>More...</ActionText>
                </Flex>}
        </NotificationBox>
    );
};

export { VersionNotification };